import axios from 'axios'

const refreshAuthApi = axios.create({
  baseURL: '/gateway/secured/auth/api/rest/v7.1.0/core/sso/refresh'
})

refreshAuthApi.interceptors.request.use((config) => {
  const headers = { ...(config.headers || {}) }

  // ✅ NO sobreescribir Authorization si ya viene en el config (el refresh_token)
  if (!headers['Authorization'] && !headers['authorization']) {
    let token = localStorage.getItem('idToken') || ''
    if (token && !/^Bearer\s/i.test(token)) token = `Bearer ${token}`
    if (token) headers['Authorization'] = token
  }

  if (process.env.API_GATEWAY_API_KEY) headers['Api-Key'] = process.env.API_GATEWAY_API_KEY

  try {
    const raw = localStorage.getItem('authSession')
    if (raw) {
      const { id, member } = JSON.parse(raw)
      if (id && !headers['Session']) headers['Session'] = id
      if (member && !headers['Member']) headers['Member'] = member
    }
  } catch { /* noop */ }

  if (!headers['Content-Type']) headers['Content-Type'] = 'application/json'

  config.headers = headers
  return config
})

export default refreshAuthApi